import * as icons from "@nulogy/icons";

const iconList = Object.keys(icons);

export default iconList;
